import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import map from 'lodash/map'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import ACL from '@components/ACL'
import MenuIcon from '@material-ui/icons/Menu'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'

import './MobileNavbar.sass'
import { NavLink } from 'react-router-dom'
import MobileLogo from './MobileLogo.js'

import { Search } from '@components/Search'

import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import BusinessCenter from '@material-ui/icons/BusinessCenter'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import PeopleIcon from '@material-ui/icons/People'
import ClientRecordsIcon from '@components/Icon/ClientRecords'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import SettingsIcon from '@material-ui/icons/Settings'
import SherlockIcon from '@components/Icon/Sherlock'
import SupportIcon from '@components/Icon/Support'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import Expert from '@components/Icon/Expert'
import ClientRecords from '@components/Icon/ClientRecords'
import ReportsIcon from '@components/Icon/Reports'

import HeaderActions from '@components/Header/HeaderActions'
class MobileNavbar extends Component {
  static propTypes = {
    activeProjectStore: PropTypes.object,
    searchStore: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false,
      subsMenuActive: {}
    }

    this.toggleDrawer = this.toggleDrawer.bind(this)
    this.toggleSubMenu = this.toggleSubMenu.bind(this)

    this.searchClick = this.searchClick.bind(this)
    this.renderMenuItem = this.renderMenuItem.bind(this)
  }

  toggleDrawer () {
    this.setState({ menuOpen: !this.state.menuOpen })
    this.props.searchStore.clean()
  }

  toggleSubMenu (index) {
    this.setState({
      subsMenuActive: {
        ...this.state.subsMenuActive,
        [index]: !this.state.subsMenuActive[index]
      }
    })
  }

  searchClick = (e, val) => {
    // When nothing selected and user hits Enter,
    // val.indexType will be empty, so we can just ignore the call
    if (!val.indexType) return

    const paths = {
      expert: 'expert',
      project: 'project',
      parent_account: 'client-search/parent-account',
      account: 'client-search/account',
      office: 'client-search/office',
      contract: 'contract',
      client: 'client-contact',
      invoice: val.projectId
        ? `project/${val.projectId}/invoice`
        : `contract/${val.contractId}/invoice`
    }

    this.props.history.push(`/${paths[val.indexType]}/${val.id}`)
    this.props.searchStore.clean()
  }

  renderIcon = ({ indexType }) => {
    switch (indexType) {
      case 'expert':
        return <Expert className='SearchIcon' />
      case 'client':
        return <Expert className='SearchIcon' />
      case 'project':
        return <ProjectsIcon className='SearchIcon' />
      case 'invoice':
        return <ReportsIcon className='SearchIcon' />
      default:
        return <ClientRecords gray className='SearchIcon' />
    }
  }

  renderMenuItem = (item, index) => {
    const className = `SearchItem ${
      index === this.props.searchStore.targetIndex ? 'SearchItem-active' : ''
    }`
    return (
      <div
        className='fastNavSearchItem'
        onClick={e => this.searchClick(e, item)}
      >
        <div className={className}>
          <div className='SearchItemText'>
            <div>
              <div className='SearchItem-itemType'>{item.itemType}</div>
              {item.menuTitle}
            </div>
            <div>
              <span title='Expert code'>{item.menuSubTitle || '-'}</span>
            </div>
          </div>
          {this.renderIcon(item)}
        </div>
      </div>
    )
  }

  render () {
    const {
      activeProjectId,
      activeProjectName,
      isActiveProjectLocked,
      resetLock
    } = this.props.activeProjectStore
    const search = this.props.searchStore

    return (
      <div className='mobile-menu'>
        <div className='mobile-menu-section'>
          <div>
            <MenuIcon
              fontSize='large'
              className='mobile-menu-icon'
              onClick={() => this.toggleDrawer()}
            />
          </div>
          <NavLink to={'/dashboard'}>
            <MobileLogo className='mobile-logo' />
          </NavLink>

          <HeaderActions />
        </div>
        <div className='mobile-search-results-container'>
          <div
            className={
              search.results.length > 0 && this.state.menuOpen
                ? 'mobile-search-results'
                : ''
            }
          >
            {map(search.results, this.renderMenuItem)}
          </div>
        </div>
        <SwipeableDrawer
          classes={{ paper: 'mobile-drawer' }}
          open={this.state.menuOpen}
          onClose={this.toggleDrawer}
          onOpen={this.toggleDrawer}
        >
          <div className='mobile-search'>
            <Search />
          </div>
          <List
            className={`mobile-menu ${
              search.results.length > 0 ? 'mobile-menu-search-results' : ''
            }`}
          >
            <ListItem
              component={NavLink}
              to={'/dashboard'}
              className='mobile-menu-item'
            >
              <ListItemIcon>
                <HomeOutlinedIcon fontSize='14' />
              </ListItemIcon>
              <ListItemText
                className='mobile-menu-item-text'
                primary='Overview'
              />
            </ListItem>
            <ListItem
              component={NavLink}
              to={'/project-management'}
              className='mobile-menu-item'
            >
              <ListItemIcon>
                <BusinessCenter fontSize='14' />
              </ListItemIcon>
              <ListItemText
                className='mobile-menu-item-text'
                primary='Project Management'
              />
            </ListItem>
            <ListItem
              className='mobile-menu-item'
              onClick={() => this.toggleSubMenu('projects')}
            >
              <ListItemIcon>
                <ProjectsIcon />
              </ListItemIcon>
              <ListItemText className='mobile-menu-item-text'>
                <div className='expand-mobile-menu-item'>
                  <span>Projects</span>
                  {this.state.subsMenuActive['projects'] ? (
                    <ArrowDropDownIcon />
                  ) : (
                    <ArrowRightIcon />
                  )}
                </div>
              </ListItemText>
            </ListItem>
            <Collapse
              in={this.state.subsMenuActive['projects']}
              timeout='auto'
              unmountOnExit
            >
              <List className='mobile-menu' disablePadding>
                <ListItem
                  component={NavLink}
                  to={'/project-search'}
                  className='mobile-menu-item'
                >
                  <ListItemText
                    className='mobile-menu-item-text'
                    primary='Project Search'
                  />
                </ListItem>
                {activeProjectId ? (
                  <ListItem
                    component={NavLink}
                    to={`/project/${activeProjectId}`}
                    className='mobile-menu-item'
                  >
                    <ListItemText className='mobile-menu-item-text'>
                      Active: <b>{activeProjectName}</b> -{' '}
                      {!isActiveProjectLocked ? (
                        <span
                          className='active-project-reset-button'
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            resetLock()
                          }}
                        >
                          Reset
                        </span>
                      ) : (
                        ''
                      )}
                    </ListItemText>
                  </ListItem>
                ) : (
                  ''
                )}
                <ListItem
                  component={NavLink}
                  to={'/my-projects'}
                  className='mobile-menu-item'
                >
                  <ListItemText
                    className='mobile-menu-item-text'
                    primary='My Projects'
                  />
                </ListItem>
              </List>
            </Collapse>
            <ListItem
              component={NavLink}
              to={'/expert-search'}
              className='mobile-menu-item'
            >
              <ListItemIcon>
                <PeopleIcon fontSize='14' />
              </ListItemIcon>
              <ListItemText
                className='mobile-menu-item-text'
                primary='Experts'
              />
            </ListItem>
            <ACL
              roles={[
                'FeeManagement',
                'Accounting',
                'AdvancedExpertManagement',
                'ProjectManagement',
                'AdvancedReporting',
                'Admin'
              ]}
            >
              <ListItem
                className='mobile-menu-item'
                onClick={() => this.toggleSubMenu('clients')}
              >
                <ListItemIcon>
                  <ClientRecordsIcon />
                </ListItemIcon>
                <ListItemText className='mobile-menu-item-text'>
                  <div className='expand-mobile-menu-item'>
                    <span>Clients</span>
                    {this.state.subsMenuActive['clients'] ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowRightIcon />
                    )}
                  </div>
                </ListItemText>
              </ListItem>
              <Collapse
                in={this.state.subsMenuActive['clients']}
                timeout='auto'
                unmountOnExit
              >
                <List className='mobile-menu' disablePadding>
                  <ListItem
                    component={NavLink}
                    to={'/client-search'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Clients records'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/client-contact-search'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Client contacts'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/contract-search'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Contracts'
                    />
                  </ListItem>
                </List>
              </Collapse>
            </ACL>

            <ACL
              roles={[
                'FeeManagement',
                'Accounting',
                'AdvancedExpertManagement',
                'ProjectManagement',
                'AdvancedReporting',
                'Admin'
              ]}
            >
              <ListItem
                className='mobile-menu-item'
                onClick={() => this.toggleSubMenu('reports')}
              >
                <ListItemIcon>
                  <InsertDriveFileIcon />
                </ListItemIcon>
                <ListItemText className='mobile-menu-item-text'>
                  <div className='expand-mobile-menu-item'>
                    <span>Reports</span>
                    {this.state.subsMenuActive['reports'] ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowRightIcon />
                    )}
                  </div>
                </ListItemText>
              </ListItem>
              <Collapse
                in={this.state.subsMenuActive['reports']}
                timeout='auto'
                unmountOnExit
              >
                <List className='mobile-menu' disablePadding>
                  <ACL
                    roles={[
                      'FeeManagement',
                      'Accounting',
                      'AdvancedExpertManagement',
                      'AdvancedReporting',
                      'Admin'
                    ]}
                  >
                    <ListItem
                      component={NavLink}
                      to={'/reports/expert-payments'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Expert payments'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['ProjectManagement']}>
                    <ListItem
                      component={NavLink}
                      to={'/reports/projects-pipeline'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Project pipeline'
                      />
                    </ListItem>
                  </ACL>
                  <ListItem
                    component={NavLink}
                    to={'/reports/created-invoices'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Created invoices'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/reports/drafted-invoices'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Drafted invoices'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/reports/revenues'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Revenues'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/reports/general-fees'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='General fees'
                    />
                  </ListItem>
                  <ACL roles={['Accounting', 'Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/reports/financial-revenue'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Financial revenue'
                      />
                    </ListItem>
                  </ACL>
                  <ListItem
                    component={NavLink}
                    to={'/reports/payments'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Payments'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/reports/performance'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Performance'
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={'/reports/currency-rates'}
                    className='mobile-menu-item'
                  >
                    <ListItemText
                      className='mobile-menu-item-text'
                      primary='Currency Rates'
                    />
                  </ListItem>
                </List>
              </Collapse>
            </ACL>

            <ACL roles={['Admin', 'HR', 'TeamManagment', 'OPSManagment']}>
              <ListItem
                className='mobile-menu-item'
                onClick={() => this.toggleSubMenu('admin')}
              >
                <ListItemIcon>
                  <SettingsIcon fontSize='14' />
                </ListItemIcon>
                <ListItemText className='mobile-menu-item-text'>
                  <div className='expand-mobile-menu-item'>
                    <span>Admin</span>
                    {this.state.subsMenuActive['admin'] ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowRightIcon />
                    )}
                  </div>
                </ListItemText>
              </ListItem>

              <Collapse
                in={this.state.subsMenuActive['admin']}
                timeout='auto'
                unmountOnExit
              >
                <List className='mobile-menu' disablePadding>
                  <ACL roles={['Admin', 'OPSManagment']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/atheneum-office'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Atheneum companies'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/compliance'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Compliance language'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin', 'OPSManagment']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/contractual-details'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Contractual details'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/department-responsible-users'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Department responsible users'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin', 'HR', 'TeamManagment']}>
                    <ListItem
                      component={NavLink}
                      to={'/employee-search'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Employees'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/epd-rejection-reason'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='ERM email templates'
                      />
                    </ListItem>

                    <ListItem
                      component={NavLink}
                      to={'/log'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Events log'
                      />
                    </ListItem>

                    <ListItem
                      component={NavLink}
                      to={'/admin/email-templates'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Email templates'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin', 'TeamManagment']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/teams'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Teams'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin', 'OPSManagment']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/units-of-work'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Units of work'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin', 'Accounting']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/booking-stop'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Booking stop'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/deployment-announcement'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Announce deployment'
                      />
                    </ListItem>
                  </ACL>
                  <ACL roles={['Admin']}>
                    <ListItem
                      component={NavLink}
                      to={'/admin/elastic-reindex'}
                      className='mobile-menu-item'
                    >
                      <ListItemText
                        className='mobile-menu-item-text'
                        primary='Reindex elastic'
                      />
                    </ListItem>
                  </ACL>
                </List>
              </Collapse>
            </ACL>

            <ACL roles={['Admin', 'OPSManagment', 'AdvancedExpertManagement']}>
              <ListItem
                component={NavLink}
                to={'/compliance-breach'}
                className='mobile-menu-item'
              >
                <ListItemIcon>
                  <SherlockIcon />
                </ListItemIcon>
                <ListItemText
                  className='mobile-menu-item-text'
                  primary='Compliance'
                />
              </ListItem>
            </ACL>

            <ListItem
              className='mobile-menu-item'
              onClick={() => this.toggleSubMenu('support')}
            >
              <ListItemIcon>
                <SupportIcon />
              </ListItemIcon>
              <ListItemText className='mobile-menu-item-text'>
                <div className='expand-mobile-menu-item'>
                  <span>Support</span>
                  {this.state.subsMenuActive['support'] ? (
                    <ArrowDropDownIcon />
                  ) : (
                    <ArrowRightIcon />
                  )}
                </div>
              </ListItemText>
            </ListItem>
            <Collapse
              in={this.state.subsMenuActive['support']}
              timeout='auto'
              unmountOnExit
            >
              <List className='mobile-menu' disablePadding>
                <ListItem
                  component={'a'}
                  href={
                    'https://atheneum-partners.atlassian.net/wiki/spaces/AA/pages/85360644/Training+Slides+New+Platform+Interface+2018'
                  }
                  className='mobile-menu-item'
                >
                  <ListItemText
                    className='mobile-menu-item-text'
                    primary='Platform academy'
                  />
                </ListItem>
                <ListItem
                  component={'a'}
                  href={
                    'https://atheneum-partners.atlassian.net/servicedesk/customer/portal/8'
                  }
                  className='mobile-menu-item'
                >
                  <ListItemText
                    className='mobile-menu-item-text'
                    primary='Create platform ticket'
                  />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </SwipeableDrawer>
      </div>
    )
  }
}

export default withRouter(
  inject('activeProjectStore', 'searchStore')(observer(MobileNavbar))
)
